// extracted by mini-css-extract-plugin
export default {"CreatePrefecture":"create-prefecture_CreatePrefecture__nURBy"};